/** Shared chart membership only; keep database and cache clients out of this module. */
/**
 * FRIDGE-1278 (owner: "when you click stuff sections on chart — it should
 * either filter or click to that page/section") — the range a clicked chart
 * section stands for. `inChartRange` is the ONE membership rule, mirroring
 * buildBins exactly: price is the lowest tracked price in dollars (> 0),
 * capacity the recorded cu ft (> 0); a bin holds [from, to), the last bin also
 * its upper edge, with buildBins' 1e-9 tolerance so a value one ulp under an
 * edge lands in the bin that edge opens. So the grid shows exactly the models
 * the section counted.
 */
export interface ChartRange {
  measure: 'price' | 'capacity'
  from: number
  to: number
  last: boolean
  /** The section's own label ("Under $2,000", "$2,000 to under $4,000", …). */
  label: string
}

export function inChartRange(p: { lowest_price_cents?: number | null; capacity_cuft?: number | string | null }, r: ChartRange): boolean {
  const x = r.measure === 'price'
    ? (p.lowest_price_cents ?? 0) > 0 ? (p.lowest_price_cents as number) / 100 : NaN
    : p.capacity_cuft === null || p.capacity_cuft === undefined ? NaN : Number(p.capacity_cuft)
  if (!Number.isFinite(x) || x <= 0) return false
  const eps = (r.to - r.from) * 1e-9
  if (x + eps < r.from) return false
  return r.last ? x <= r.to + eps : x + eps < r.to
}
